import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

function Footer() {
  return (
    <footer className="bg-[#0A2A66] text-white py-10">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6">
        {/* Logo + name */}
        <div className="flex items-center space-x-3 mb-6 md:mb-0">
          <img src={logo} alt="QuantNexusCapital Logo" className="h-8 w-auto" />
          <span className="font-semibold text-lg">QuantNexusCapital</span>
        </div>

        {/* Links */}
        <div className="flex space-x-6 text-sm font-medium">
          <Link to="/disclaimer" className="hover:text-cyan-300 transition">
            Disclaimer
          </Link>
          <Link to="/privacy-policy" className="hover:text-cyan-300 transition">
            Privacy Policy
          </Link>
          <Link
            to="/terms-and-conditions"
            className="hover:text-cyan-300 transition"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>

      {/* Copyright */}
      <p className="text-center text-xs text-white/70 mt-6">
        © {new Date().getFullYear()} QuantNexusCapital. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
